<template> 
<div>
    <div class="basic-2">
        <div class="container">
            <div class="row">
                <div class="col-lg-12">
                    <div class="text-container">
                        <h4 class="text-center" >About Us</h4>
                        <p class="p-large" style="text-align: justify">
                          As you know, in addition to increasing the level of human well-being, the advancement of technology around the world has changed the way of life and many businesses. So that in many advanced countries, most businesses have left the traditional way, or at least they have helped their survival by integrating technology. The goal of the professional team of web consultants is to help small and individual or start-up businesses, so that they can step into the digital world and take a step towards a professional business. If you haven't started yet, contact us now and choose the best plan to start.
                        </p>
                    </div> <!-- end of text-container -->
                </div> <!-- end of col -->
            </div> <!-- end of row -->
        </div> <!-- end of container -->
    </div> <!-- end of basic-2 -->
  </div>
</template>

<script>
export default {
name:'AboutEn',
}
</script>

<style>

</style>